import { algorand } from "@/lib/clients";
import { useQuery } from "@tanstack/react-query";
import { BenchRegistryClient } from "@myth-finance/bench-sdk";
import { benchRegistryAppId, network } from "@/config";
import { N } from "@/lib/utils";
import { queryClient } from "@/lib/query-client";
import { queryKeyPrefix as allQueryKeyPrefix, BenchIndexStates } from "./use-all-bench-states";

const queryKeyPrefix = "benchappid";

export const useBenchAppId = (benchId: number | undefined) => {
  const queryKey = [queryKeyPrefix, String(benchId)];
  return useQuery({
    queryKey,
    gcTime: network === "localnet" ? 30_000 : Infinity,
    staleTime: network === "localnet" ? 30_000 : Infinity,
    enabled: benchId !== undefined,
    queryFn: async (): Promise<bigint | null> => {
      if (benchId === undefined) return 0n;
      console.log("Getting benchappid", benchId);
      let cached;
      if ((cached = getCachedAppID(benchId))) {
        console.log("Cached benchappid", benchId, cached);
        return cached;
      }
      const sdk = new BenchRegistryClient({
        algorand,
        registryAppId: benchRegistryAppId,
      });
      const registryKeys = await sdk.getRegistryKeys();
      const rk = registryKeys.find(({ id }) => N(id) === benchId);
      if (!rk) {
        setTimeout(() => queryClient.invalidateQueries({ queryKey }), 10_000);
        return null;
      }
      try {
        const stateMap = await sdk.getBenchSmallStates([rk]);
        const state = [...stateMap.values()][0];
        return state.appId;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
  });
};

function getCachedAppID(benchId: number): bigint | undefined {
  const allStates = (queryClient.getQueryData([allQueryKeyPrefix]) ??
    {}) as BenchIndexStates;
  for (const state of Object.values(allStates).flat()) {
    if (state.benchId === benchId) return state.appId;
  }
  return;
}

export const clearBenchAppIdCache = (benchId?: bigint) => {
  const queryKey = [queryKeyPrefix, String(benchId)];
  if (benchId) queryKey.push(String(benchId));
  queryClient.invalidateQueries({ queryKey });
};
